module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Kontakt")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Dane firmy",
      "error": _vm.errors['contact.companyData']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "10"
    },
    model: {
      value: (_vm.contact.companyData),
      callback: function($$v) {
        _vm.contact.companyData = $$v
      },
      expression: "contact.companyData"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Telefony",
      "error": _vm.errors['contact.phonesData']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "10"
    },
    model: {
      value: (_vm.contact.phonesData),
      callback: function($$v) {
        _vm.contact.phonesData = $$v
      },
      expression: "contact.phonesData"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Email do wiadomości",
      "error": _vm.errors['contact.contactEmail']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.contact.contactEmail),
      callback: function($$v) {
        _vm.contact.contactEmail = $$v
      },
      expression: "contact.contactEmail"
    }
  })], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35a02cfe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 436
// module chunks = 1